import { MaintenanceWindowManuallyApprovedPatchesSelectorGzDataProvider } from '../dataProvider/MaintenanceWindowManuallyApprovedPatchesSelectorGzDataProvider';
import { BaseWebComponentDataProviderFactory } from '../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ } from '../../../webcomponents.constants';

export class MaintenanceWindowManuallyApprovedPatchesSelectorDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, MaintenanceWindowManuallyApprovedPatchesSelectorGzDataProvider);
  }
}
